import { useQuery } from '@tanstack/vue-query';
import { computed, type Ref, unref } from 'vue';

import receiptModelApiService from '~/services/receipt-model-api/receipt-model-api';

export default function useReceiptModel(projectId: Ref<string> | string) {
  return useQuery({
    enabled: computed(() => !!unref(projectId)),
    queryFn: async () => {
      const id = unref(projectId);
      if (!id) throw new Error('Project ID is required');
      return receiptModelApiService.getReceiptModel(id);
    },
    queryKey: computed(() => ['receipt-model', unref(projectId)]),
    retry: 3,
  });
}
